<div class="fm-search-light-category-results-menu" *ngIf="shouldShowMenu()">
  <fm-menu-panel (menuOptionKeydown)="onMenuOptionKeydown($event)">
    <div class="fm-search-light-category-results-menu__list">
      <fm-menu-option
        *ngFor="let categoryResult of category.items"
        [class.fm-search-light-category-results-menu--disabled]="!categoryResult.lat || !categoryResult.lng"
        fmTooltip="Driver not assigned to a vehicle"
        i18n-fmTooltip="@@S_LIVEMAP_SEARCH_DRIVER_NOT_ASSIGNED"
        [shouldDisplayFmTooltip]="categoryResult.type === 2 && categoryResult.meta === null"
        [fmTooltipXOffset]="5"
        [fmTooltipYOffset]="15"
        fmTooltipClass="fm-search-light-tooltip"
        (menuOptionSelected)="onMenuOptionSelected(categoryResult)"
        (hover)="onMenuOptionHovered(categoryResult)"
      >
        {{ categoryResult.text }}
      </fm-menu-option>
    </div>
  </fm-menu-panel>
</div>
